import { ListItem as CssModulesListItem, type ListItemProps } from '@sunwebgroup/uds-ui/list-item'
import { styled } from 'styled-components'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/list-item' instead.
 */
const StyledListItem = styled(CssModulesListItem)<ListItemProps>``

export default StyledListItem
